import React from 'react';
import { connect } from 'react-redux';
import { Link, withRouter } from 'react-router-dom';
import { MenuItem, Dropdown, Button } from 'react-bootstrap';
import { injectIntl } from 'react-intl';
import { confirmAlert } from 'react-confirm-alert';
import { getNameInCurrentLanguage } from 'helpers/intl';
import ShareEdition from 'components/layout/campaigns/ShareEdition';
import { ROLE_ROOT_EMPLOYEE, PROJECT_NAME } from 'js/constants';
import { forEach as _forEach } from 'lodash';
import SimplePrompt from '../SimplePrompt';
import { deleterDispatchHelper } from '../../../actions/DeleterActions';
import EditionPreviews from './EditionPreviews';
import { cartAddEdition } from '../../../actions/CartActions';
import { checkEditionErrors } from '../../../helpers/edition';
import may from '../../../security';
import { getPDFR, getPrintDataR, setVariables } from '../../../actions/CampaignActions';
import { setVariablesAboutListRData, markEditionR } from '../../../actions/DataActions';
import { markRecentEditionR, unmarkMarkedEditionR } from '../../../actions/ListActions';
import { getDeviceType } from '../../../cc-editor/components/actions/deviceType';

class Edition extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      previewing: false,
    };
  }

  componentDidUpdate = () => {
    const { exeThen, setVariablesAboutListRData } = this.props;

    if (exeThen === 'startForceUpdate') {
      setVariablesAboutListRData('startForceUpdateReset');
    }
  };

  getPDF = (type, editionId) => {
    // set previewing to editionID
    const { setVariables } = this.props;
    const {
      intl: { messages },
    } = this.props;
    setVariables(editionId);
    setVariables(type);
    this.setState({
      previewing: editionId,
    });
    let api = 'previewcopies';
    if (type === 'print') {
      api = 'mastercopies';
    } else if (type === 'image') {
      api = 'images/mastercopies';
    } else if (type === 'video') {
      api = 'images/mastercopies'; // Todo api -> images/ or videos/
    }
    const { getPDFR, getPrintDataR, edition } = this.props;
    if (edition?.template?.direct_ordering) {
      const printDataLink =
        'https://s3.eu-central-1.amazonaws.com/' +
        PROJECT_NAME +
        '.templates/' +
        edition?.template?.id +
        '/printData/' +
        edition?.template?.print_data;
      getPrintDataR(editionId, messages, printDataLink);
    } else {
      getPDFR(api, editionId, messages);
    }
  };

  markEdition = (editionId, mark) => {
    const { markEditionR, markRecentEditionR, unmarkMarkedEditionR, markOption } = this.props;

    switch (markOption) {
      case 'recent':
        markRecentEditionR(editionId, mark);
        break;
      case 'marked':
        unmarkMarkedEditionR(editionId, mark);
        break;
      default:
        markEditionR(editionId, mark);
    }
  };

  addToCart = () => {
    const { edition, addToCart, history, appIntl, messages } = this.props;
    addToCart(edition);
    let cart = 'cart';
    if (appIntl.urlPrefix === '/de/') {
      cart = 'warenkorb';
    }
    const options = {
      title: messages.campaign.edition_add_to_cart_title,
      message: edition.title + messages.campaign.edition_added_to_cart_message,
      buttons: [
        {
          label: messages.campaign.edition_add_to_cart_button_label,
          onClick: () => {},
        },
        {
          label: messages.campaign.edition_add_to_cart_label,
          onClick: () => {
            history.push(appIntl.urlPrefix + cart);
          },
        },
      ],
      childrenElement: () => <div />,
      closeOnEscape: true,
      closeOnClickOutside: true,
    };

    confirmAlert(options);
  };

  webPreview = () => {
    const { edition } = this.props;
    const preview = window.open(
      window.location.protocol + '//' + window.location.hostname + '/de/website/' + edition.id,
      '_blank'
    );
    preview.focus();
  };

  closeShareEdition = () => {
    this.setState({ showShare: false });
  };

  render() {
    const {
      messages,
      appIntl,
      edition,
      deleting,
      deleter,
      isEditionInCart,
      copyEdition,
      user,
      previewingR,
      viewOnly,
      isSelected,
      markOption,
    } = this.props;

    const lastEdit = new Date(edition.mdate);
    const created = new Date(edition.cdate);
    const options = { weekday: 'short', year: 'numeric', month: '2-digit', day: 'numeric' };
    let disablePreview = false;
    const editionErrors = checkEditionErrors(edition, messages);
    let editionOrdered = false;
    let disableOptions = false;

    if (edition?.template === null || edition?.template === undefined || typeof edition?.template === 'undefined') {
      disableOptions = true;
    }

    if (typeof edition.placed_orders && edition.placed_orders && edition.placed_orders.length > 0) {
      editionOrdered = true;
    }

    if (previewingR !== false) {
      disablePreview = true;
    }

    let disabledOwn = 'edition';
    let active = true;
    if (edition.template && !edition?.template?.is_active && !may(ROLE_ROOT_EMPLOYEE, user.roles)) {
      disabledOwn = 'edition disabledOwn tooltip2';
      active = false;
    }

    let itemName;
    edition.item && typeof edition?.item.name === 'object'
      ? (itemName = getNameInCurrentLanguage(edition?.item.name, appIntl))
      : (itemName = edition?.item.name);

    let shared = '';
    if (typeof edition.shared_with_users !== 'undefined' && edition.shared_with_users.length > 0) {
      shared = ' shared_edition ';
    }

    let _mayBeShared = false;
    if (edition.may_be_shared || this.props.user?.username === edition?.creator?.username) {
      _mayBeShared = true;
    }

    let orderAllowed = true;
    if (edition?.template?.placeholder === true && edition?.placeholder === null) {
      orderAllowed = false;
    }

    let sharedOrderAllowed = false;
    if (may('ROLE_ADMIN', user.roles) || edition?.creator?.username === user?.username) {
      sharedOrderAllowed = true;
    }

    const printDataPreviews = [];
    _forEach(edition?.template?.print_data_previews, preview => {
      printDataPreviews.push({
        key:
          'https://s3.eu-central-1.amazonaws.com/' +
          PROJECT_NAME +
          '.templates/' +
          edition?.template?.id +
          '/images/' +
          preview,
      });
    });

    return (
      <>
        {edition.item && (
          <div
            style={{ opacity: isSelected || !viewOnly ? 1 : 0.5, pointerEvents: viewOnly ? 'none' : 'auto' }}
            className={disabledOwn}
            id={edition.id}
            key={edition.id}
          >
            {!active ? (
              <div className="tooltiptext2">
                <span>
                  <i className="fas fa-comment-exclamation iOwnClass" />
                  {messages.campaign.edit_disabled}
                </span>
              </div>
            ) : (
              <></>
            )}

            <header>
              {!viewOnly && (
                <div className="header-left">
                  <Dropdown id={'settings-' + edition.id}>
                    <Dropdown.Toggle noCaret className="bg-red">
                      <i className="fas fa-bars" />
                    </Dropdown.Toggle>
                    {!disableOptions ? (
                      <Dropdown.Menu>
                        {!editionOrdered ||
                          (!edition?.template?.is_active && !may(ROLE_ROOT_EMPLOYEE, user.roles) && (
                            <MenuItem href={appIntl.urlPrefix + 'editor/' + edition.id}>
                              {messages.campaign.edition_edit_alt}
                            </MenuItem>
                          ))}
                        {edition.template && edition.template.export_type.value === '000000000000000000000001' ? (
                          <MenuItem disabled={disablePreview} onClick={() => this.getPDF('image', edition.id)}>
                            {messages.campaign.export_image}{' '}
                            {previewingR === edition.id && <i className="fa fa-spin fa-spinner-third" />}
                          </MenuItem>
                        ) : edition.template && edition.template.export_type.value === '000000000000000000000003' ? (
                          <MenuItem disabled={disablePreview} onClick={() => this.webPreview()}>
                            {messages.campaign.edition_preview}{' '}
                            {previewingR === edition.id && <i className="fa fa-spin fa-spinner-third" />}
                          </MenuItem>
                        ) : edition.template && edition.template.export_type.value === '000000000000000000000004' ? (
                          <MenuItem disabled={disablePreview} onClick={() => this.getPDF('video', edition.id)}>
                            {messages.export_video}{' '}
                            {previewingR === edition.id && <i className="fa fa-spin fa-spinner-third" />}
                          </MenuItem>
                        ) : (
                          <MenuItem disabled={disablePreview} onClick={() => this.getPDF('preview', edition.id)}>
                            {messages.campaign.edition_preview}{' '}
                            {previewingR === edition.id && <i className="fa fa-spin fa-spinner-third" />}
                          </MenuItem>
                        )}
                        {markOption !== 'shared' && (
                          <>
                            <MenuItem onClick={() => copyEdition('', 'copy', edition.id)}>
                              {messages.campaign.copy_edition}
                            </MenuItem>
                            {edition.marked ? (
                              <MenuItem onClick={() => this.markEdition(edition.id, false)}>
                                {messages.campaign.unmark_edition}
                              </MenuItem>
                            ) : (
                              <MenuItem onClick={() => this.markEdition(edition.id, true)}>
                                {messages.campaign.mark_edition}
                              </MenuItem>
                            )}
                            {!editionOrdered && (
                              <MenuItem href="#">
                                <SimplePrompt
                                  disabled={deleting || editionOrdered}
                                  iconClass="no-icon"
                                  onSuccess={e => {
                                    deleter(e, edition.id);
                                  }}
                                />
                              </MenuItem>
                            )}
                          </>
                        )}
                      </Dropdown.Menu>
                    ) : !editionOrdered ? (
                      <Dropdown.Menu>
                        <MenuItem href="#">
                          {markOption !== 'shared' ? (
                            <SimplePrompt
                              disabled={deleting || editionOrdered}
                              iconClass="no-icon"
                              onSuccess={e => {
                                deleter(e, edition.id);
                              }}
                            />
                          ) : (
                            <></>
                          )}
                        </MenuItem>
                      </Dropdown.Menu>
                    ) : (
                      <Dropdown.Menu>
                        <MenuItem href="#">
                          <></>
                        </MenuItem>
                      </Dropdown.Menu>
                    )}
                  </Dropdown>
                </div>
              )}
              <div className="header-fill">
                <h4>
                  {itemName + ' '}
                  {editionErrors.length > 0 && <i className="error fas fa-exclamation-triangle" />}
                  {edition.template && !edition?.template?.is_active && !may(ROLE_ROOT_EMPLOYEE, user.roles) && (
                    <i className="fal fa-debug" />
                  )}
                  {edition?.template?.direct_ordering && <i className="fal fa-cart-arrow-down" />}
                  {editionOrdered ? (
                    <span class="edition_title bold" style={{ color: '#B2CE4C' }}>
                      {' '}
                      {messages.campaign.ordered}
                    </span>
                  ) : (
                    <></>
                  )}
                </h4>
              </div>
              {!viewOnly && (
                <div className="header-right">
                  {_mayBeShared ? (
                    <Button
                      className={'btn btn-default' + shared}
                      onClick={() => {
                        this.setState({ showShare: true });
                      }}
                    >
                      <i className="far fa-share-alt" />
                    </Button>
                  ) : (
                    <></>
                  )}
                </div>
              )}
            </header>
            <div className="details" style={{ borderBottom: viewOnly ? '' : '1px solid black' }}>
              <div className="details-content">
                <div className="row">
                  <div className="col-md-7 p-l-0">
                    <p>
                      <span>{messages.campaign.edition_title + ':'}</span>
                      <span className="edition_title">{edition.title}</span>
                    </p>
                    <p>
                      <span>{messages.campaign.created_by}</span>
                      <span className="edition_title">
                        {edition.creator
                          ? edition.creator.profile.first_name + ' ' + edition.creator.profile.last_name
                          : messages.campaign.unknown}
                      </span>
                    </p>
                  </div>
                  <div className="col-md-5 p-r-0 text-right">
                    <p>
                      <span>{messages.campaign.last_edited}</span>
                      <span className="w110">{lastEdit.toLocaleDateString('de-DE', options)}</span>
                    </p>
                    <p>
                      <span>{messages.campaign.generated}</span>
                      <span className="w110">{created.toLocaleDateString('de-DE', options)}</span>
                    </p>
                  </div>
                </div>
                <EditionPreviews
                  key={'previews_' + edition.id}
                  editionPreviews={edition?.template?.direct_ordering ? printDataPreviews : edition.previews}
                  type={edition?.template?.export_type?.value}
                />
              </div>
            </div>
            {!viewOnly && (
              <footer>
                <div className="footer-left">
                  {disableOptions && (
                    <p>
                      <span className="text-danger">
                        <i className="fad fa-exclamation-triangle" /> {messages.template_deleted_warning}
                      </span>
                    </p>
                  )}
                  {editionErrors.map(error => {
                    return (
                      <p key={error.info}>
                        {!edition.template?.direct_ordering && (
                          <>
                            <i className="error fas fa-exclamation-triangle" /> {error.info}
                          </>
                        )}
                      </p>
                    );
                  })}
                </div>
                {!disableOptions && (
                  <div className="footer-right">
                    {editionOrdered &&
                    !may(ROLE_ROOT_EMPLOYEE, user.roles) &&
                    edition.template &&
                    edition.template.export_type.value !== '000000000000000000000003' ? (
                      <Link disabled to="#" class="start-editor btn-rounded btn btn-sm btn-default tooltip">
                        <div class="tooltiptext">
                          <span>
                            <i className="fas fa-comment-exclamation iOwnClass" /> {messages.campaign.already_ordered}
                            <i className="fas fa-bars" />
                          </span>
                        </div>
                        <i className="fa fa-pencil-alt" /> {messages.campaign.edition_edit}
                      </Link>
                    ) : edition.template && !edition?.template?.is_active && !may(ROLE_ROOT_EMPLOYEE, user.roles) ? (
                      <Link disabled to="#" class="start-editor btn-rounded btn btn-sm btn-default tooltip">
                        <i className="fa fa-pencil-alt" /> {messages.campaign.edition_edit}
                      </Link>
                    ) : (this.props.onMobile || getDeviceType() === 'desktop' || getDeviceType() === 'tablet') &&
                      !edition.template?.direct_ordering ? (
                      <Link
                        to={appIntl.urlPrefix + 'editor/' + edition.id}
                        class="start-editor btn-rounded btn btn-sm btn-default"
                      >
                        <i className="fa fa-pencil-alt" /> {messages.campaign.edition_edit}
                      </Link>
                    ) : (
                      <></>
                    )}
                    {edition.template && edition.template.export_type.value === '000000000000000000000001' ? (
                      <Button
                        class="order-edition btn-rounded btn btn-sm btn-default"
                        onClick={() => {
                          this.getPDF('image', edition.id);
                        }}
                      >
                        <i className={previewingR === edition.id ? 'fad fa-spinner-third fa-spin' : 'far fa-image'} />{' '}
                        {messages.campaign.export_image}
                      </Button>
                    ) : edition.template && edition.template.export_type.value === '000000000000000000000004' ? (
                      <Button
                        class="order-edition btn-rounded btn btn-sm btn-default"
                        onClick={() => {
                          this.getPDF('video', edition.id);
                        }}
                      >
                        <i className={previewingR === edition.id ? 'fad fa-spinner-third fa-spin' : 'far fa-image'} />{' '}
                        {messages.export_video}
                      </Button>
                    ) : isEditionInCart || !orderAllowed || !sharedOrderAllowed ? (
                      <Button class="order-edition btn-rounded btn btn-sm btn-default" disabled>
                        <i className="fa fa-plus" /> {messages.campaign.edition_order}
                      </Button>
                    ) : editionOrdered && sharedOrderAllowed ? (
                      <Button class="order-edition btn-rounded btn btn-sm btn-default" onClick={this.addToCart}>
                        <i className="fas fa-redo" /> {messages.campaign.edition_reorder}
                      </Button>
                    ) : (
                      <Button class="order-edition btn-rounded btn btn-sm btn-default" onClick={this.addToCart}>
                        <i className="fa fa-plus" /> {messages.campaign.edition_order}
                      </Button>
                    )}
                  </div>
                )}
              </footer>
            )}
            <ShareEdition
              mayBeShared={_mayBeShared}
              listOfSharedUsers={edition?.shared_with_users}
              editionId={edition.id}
              show={this.state.showShare}
              close={this.closeShareEdition}
            />
          </div>
        )}
      </>
    );
  }
}

const mapDispatchToProps = dispatch => {
  return {
    deleteCampaign: campaignId => {
      deleterDispatchHelper('campaign', '/api/campaigns/' + campaignId + '.json', dispatch);
    },
    deleteEdition: editionId => {
      deleterDispatchHelper('edition', '/api/editions/' + editionId + '.json', dispatch);
    },
    addToCart: edition => {
      dispatch(cartAddEdition(edition));
    },
    getPDFR: (data, datab, messages, printData) => {
      dispatch(getPDFR(data, datab, messages, printData));
    },
    getPrintDataR: (editionId, messages, printData) => {
      dispatch(getPrintDataR(editionId, messages, printData));
    },
    markEditionR: (data, datab) => {
      dispatch(markEditionR(data, datab));
    },
    markRecentEditionR: (data, datab) => {
      dispatch(markRecentEditionR(data, datab));
    },
    unmarkMarkedEditionR: (data, datab) => {
      dispatch(unmarkMarkedEditionR(data, datab));
    },
    setVariablesAboutListRData: data => {
      dispatch(setVariablesAboutListRData(data));
    },
    setVariables: data => {
      dispatch(setVariables(data));
    },
  };
};

const mapStateToProps = (state, { edition }) => {
  return {
    isEditionInCart: !!state.cart.items.find(item => item.edition.id === edition.id),
    user: state.login.user,
    previewingR: state.campaigns.previewingR,
    exeThen: state.data.campaign.exeThen,
  };
};

export default withRouter(
  injectIntl(
    connect(
      mapStateToProps,
      mapDispatchToProps
    )(Edition)
  )
);
